import React, { useEffect, useState } from 'react';
import { msalConfigAssociate, msalConfigPhmc } from './authConfig';
import Navigation from './components/core/Navigation';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { Button, Modal } from 'react-bootstrap';

import { Card, Col, Row, Table, Carousel } from 'react-bootstrap';
const SignIn = () => {
    const [msalConfig, setMslConfig] = useState(null);
    const handleSignIn = (user) => {
        setMslConfig(user === 'phmc' ? msalConfigPhmc : msalConfigAssociate);
        sessionStorage.setItem('msalConfig', msalConfig);
    };
    const accounts = useMsal();
    useEffect(() => {
        console.log(accounts);
        const config = sessionStorage.getItem('msalConfig');
        console.log(`config : ${config}`);
    })

    const imageInterval = 20000;

    const images = [
        './img/p11.jpg',
        './img/p12.jpg',
        './img/p13.jpg',
        './img/p14.jpg',
        './img/p15.jpg',
        './img/p16.jpg',
        './img/p17.jpg',

    ];
    return (
        <div>
            {!msalConfig && (<>
                <div
                    className="modal show"
                    style={{ display: 'block', position: 'initial' }}
                >
                    <Row>
                        <Col md={2} ></Col>
                        <Col md={8} >
                            <Modal.Dialog>
                                <Modal.Header >
                                    <Modal.Title>Welcome to PHMC Reporting</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <p>Login to Access Reporting</p>
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button variant="primary" onClick={() => handleSignIn('phmc')}>CWOPA Login</Button>
                                    <Button variant="primary" onClick={() => handleSignIn('associate')}>Non-CWOPA Login</Button>
                                </Modal.Footer>

                            </Modal.Dialog>
                        </Col>
                    </Row>
                    {/* <RandomPictureCard /> */}
                    <Carousel data-bs-theme="light">
                        {images.map((image, index) => (
                            <Carousel.Item interval={imageInterval} key={index}>
                                <Card>
                                    <Card.Img variant="top" src={image} />
                                    <Col />
                                    <Col >
                                        <img src="PHMC-Reports-Web-white.png"
                                            className="overlay-image"

                                            alt="phmc logo"
                                        />
                                        <div className='overlay'>
                                            <Card.Body className='modal-content'>
                                                <div className='modal-header' >
                                                    <p><b>Statement of Purpose</b></p>
                                                </div>
                                                <div className='modal-body'>
                                                    <p>PHMC Reports is a digital tool for the efficient collection and storage of data,
                                                        providing PHMC and its partners with the ability to measure and evaluate performance
                                                        as well as to promote the positive impacts PHMC historic sites and museums have on visitors,
                                                        local communities and the Commonwealth.</p>  </div>
                                            </Card.Body>
                                        </div>
                                    </Col>
                                    <Col />

                                </Card>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
            </>
            )
            }
            {
                msalConfig && (
                    <MsalProvider instance={new PublicClientApplication(msalConfig)}>
                        <Navigation />
                    </MsalProvider>
                )
            }

        </div >
    );
};

export default SignIn;